import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AngularSplitModule } from 'angular-split';
import { GridModule } from './components/grid/grid.module';
import { MapModule } from './components/map/map.module';
import { SearchMapMenuModule } from './components/search-map-menu/search-map-menu.module';

import { SearchComponent } from './components/search/search.component';
import { ChangeRegionComponent } from './components/change-region/change-region.component';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { MySearchComponent } from './components/my-search/my-search.component';
import { QuickSearchComponent } from './components/quick-search/quick-search.component';
import { SearchFormListComponent } from './components/search-form-list/search-form-list.component';
import {
  CustomizeSearchResultViewComponent
} from './components/customize-search-result-view/customize-search-result-view.component';
import { EditSearchComponent } from './components/edit-search/edit-search.component';
import { CustomizeExportComponent } from './components/customize-export/customize-export.component';
import { ActionDropdownComponent } from './components/action-dropdown/action-dropdown.component';
import { SearchMaximumResultsComponent } from './components/search-maximum-results/search-maximum-results.component';
import { PictureViewerComponent } from './components/picture-viewer/picture-viewer.component';
import { PropertySuggestionComponent } from './components/property-suggestion/property-suggestion.component';
import { SelectFromListModalComponent } from './components/select-from-list-modal/select-from-list-modal.component';
import { SearchAttributesModalComponent } from '@root/search/components/search-attributes-modal/search-attributes-modal.component';
import { PropertySortModalComponent } from './components/property-sort-modal/property-sort-modal.component';
import { PremiumMapComponent } from './components/premium-map/premium-map.component';
import { DisclaimerModalComponent } from './components/disclaimer-modal/disclaimer-modal.component';

@NgModule({
  declarations: [
    SearchComponent,
    ChangeRegionComponent,
    SearchPanelComponent,
    MySearchComponent,
    QuickSearchComponent,
    SearchFormListComponent,
    CustomizeSearchResultViewComponent,
    ActionDropdownComponent,
    EditSearchComponent,
    CustomizeExportComponent,
    SearchMaximumResultsComponent,
    PictureViewerComponent,
    PictureViewerComponent,
    PropertySuggestionComponent,
    SelectFromListModalComponent,
    SearchAttributesModalComponent,
    PropertySortModalComponent,
    PremiumMapComponent,
    DisclaimerModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    GridModule,
    MapModule,
    AngularSplitModule,
    SearchMapMenuModule,
    PopoverModule.forRoot()
  ],
  providers: [
    DatePipe
  ],
  exports: [
    ChangeRegionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SearchModule {
}
